/** Tipi condivisi tra i modali selettive (PWA). */

export interface ActiveSelective {
  id: string;
  type: string;
  priority: string;
  callerInfo?: string;
  recipient?: string;
  zone?: string;
  notes?: string;
  createdAt: string;
  createdByName?: string;
  acceptedCount: number;
  rejectedCount: number;
  arrivedCount: number;
  totalTargets?: number;
  /** Timestamp (ISO) in cui e' stato segnalato "intervento non piu' necessario". Null/assente = mai segnalato. */
  noLongerNeededAt?: string | null;
}

/** Profilo VVF: grado + competenze visualizzati nella user list (Bryan). */
export interface VvfProfile {
  vvfGrade?: string;
  competenceAutista?: boolean;
  competenceAutistaVvfLevel?: string;
  competenceTpss?: boolean;
  competenceAtp?: boolean;
  competenceSaf?: boolean;
  competenceNbcr?: boolean;
  competenceTas?: boolean;
}

export type RespUser = {
  userId: string;
  nickname: string;
  email: string;
  phoneNumber?: string | null;
  latitude?: number;
  longitude?: number;
  respondedAt: string;
} & VvfProfile;

export interface ResponsesData {
  accepted: RespUser[];
  rejected: RespUser[];
  arrived: RespUser[];
  noResponse: Array<{ userId: string; nickname: string; email: string }>;
}

export interface TenantUser {
  id: string;
  nickname: string;
  email: string;
  isOperative: boolean;
}

export interface SelectiveForm {
  type: string;
  priority: 'Alta' | 'Media' | 'Bassa';
  callerInfo: string;
  recipient: string;
  zone: string;
  notes: string;
  target: 'All' | 'Available' | 'Custom';
  customUserIds?: string[];
}

export const TYPE_OPTIONS = [
  { value: '', label: 'Tipo intervento', placeholder: true },
  { value: 'Incendio',  label: '🔥 Incendio' },
  { value: 'Soccorso',  label: '🚑 Soccorso' },
  { value: 'Incidente', label: '🚗 Incidente' },
  { value: 'Altro',     label: '📝 Altro' },
];

export const PRIORITY_OPTIONS = [
  { value: 'Alta',  label: '🔴 Alta',  color: '#dc3545' },
  { value: 'Media', label: '🟠 Media', color: '#ff9800' },
  { value: 'Bassa', label: '🟢 Bassa', color: '#28a745' },
] as const;

export const VVF_GRADE_SHORT: Record<string, string> = {
  VF: 'VF', CS: 'CS', CR: 'CR', VI: 'VI', IS: 'IS',
};

export const inputStyle: React.CSSProperties = {
  width: '100%', padding: 12, margin: '8px 0',
  border: '2px solid #ddd', borderRadius: 8, fontSize: 16,
  boxSizing: 'border-box',
};

export function formatCompetenze(u: VvfProfile): string[] {
  const out: string[] = [];
  if (u.competenceAutista) out.push(u.competenceAutistaVvfLevel ? `Autista ${u.competenceAutistaVvfLevel}` : 'Autista');
  if (u.competenceTpss) out.push('TPSS');
  if (u.competenceAtp) out.push('ATP');
  if (u.competenceSaf) out.push('SAF');
  if (u.competenceNbcr) out.push('NBCR');
  if (u.competenceTas) out.push('TAS');
  return out;
}
